module.exports = __webpack_public_path__ + "img/under-contribute.830e8db0.png";